import { OneServiceI18n } from './i18n';
export { ContentfulBackend } from './i18n/backends';
export { MxContextLanguageDetector } from './i18n/language-detectors';
export var createI18n = function () { return new OneServiceI18n(); };
